var React = require('react');

function Key (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M10 11.414l-1.793 1.793a1 1 0 1 1-1.414-1.414L8.586 10 7.032 8.446a4 4 0 1 1 1.414-1.414l6.261 6.26a1 1 0 0 1-1.414 1.415l-1.043-1.043-1.043 1.043a1 1 0 1 1-1.414-1.414l1.043-1.043-.836-.836zM5 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"}));
}

Key.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Key;

Key.default = Key;
